

declare interface Loja {
  latitude: string;
  longitude: string;
  cod: string,
  param: string
}


import {
  IonPage,
  IonContent ,
  IonItem,
  IonMenu,
  IonAlert,
  IonApp,
  IonList,
  IonLabel,
  IonListHeader,
  IonMenuToggle,
  IonToolbar,
  IonButton,
  IonFooter,
  IonIcon,
  IonTitle,
  IonInput,
  IonBackButton,
  IonAccordion,
  IonAccordionGroup,
  IonNote,
  IonBadge,
  IonSkeletonText,
  IonCol,
  IonAvatar,
  IonRow,
  IonSpinner,
  IonRadio,
  IonRadioGroup

} from '@ionic/vue';

import { Capacitor } from '@capacitor/core';

import { cart, chevronBackCircle,chevronBack,mapOutline,locationOutline  } from 'ionicons/icons';

import fintailapi from "../api";

import {useStore} from "vuex";
import { defineComponent } from 'vue';
import SafeArea  from '../components/SafeArea.vue'

import FooterMenu from '../components/FooterMenu.vue'

export default defineComponent({
  components: {
    IonContent,
    IonPage,
    IonItem,
    IonAlert,
    IonList,
    IonMenu,
    IonInput,
    IonButton,
    IonTitle,
    IonToolbar,
    IonApp,
    IonIcon,
    IonLabel,
    IonSpinner,
    IonListHeader,
    IonMenuToggle,
    IonFooter,
    IonBackButton,
    IonAccordion,
    IonAccordionGroup,
    IonNote,
    IonSkeletonText,
    IonCol,
    IonAvatar,
    IonRow,
    IonBadge,
    IonRadio,
    
    IonRadioGroup,
    SafeArea,
    FooterMenu,
    Capacitor
  },
  data() {
    return {
      nomeCidade: null,
      carregando: true,
      store : useStore(),
      cart,
      chevronBackCircle,
      mapOutline,
      locationOutline,
      chevronBack,
      lojas_cadastradas: [],
      isOpenRef : false
    }
  },
  computed: {
    lojas() {
      let filter = ""
      if (this.nomeCidade) {
        filter = this.nomeCidade
        return this.lojas_cadastradas.filter( (poke:any) =>
          poke[0].cidade.toLowerCase().includes(filter.toLowerCase())
        )
      } else {
        return this.lojas_cadastradas;
      }
    }
  },
  created(){

    fintailapi
    .post('/lojas', { "id": "stores"   })
    .then((response:any) => {
        this.carregando=false
        const data = response.data
        if(data.success){
          this.lojas_cadastradas = data.lojas
        }

     })
   // this.store.dispatch('loadLocationData', false)

  },
  methods: {
    setOpen(state: boolean){
       this.isOpenRef = state
    },
    voltar() {
      this.$router.back()
    },
    showMap(loja:Loja) {

      if (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'web') {
        window.open("http://www.google.com/maps/place/".concat(loja.latitude).concat(',').concat(loja.longitude), '_blank');
      }else{
        window.open("http://maps.apple.com/?ll=".concat(loja.latitude).concat(',').concat(loja.longitude), '_blank');
      }

    }
  },
});


/*
  horarios = {"1002":["Fechado","Fechado","07:30 as 19:30","Fechado","Fechado","07:30 as 19:30"],"1003":["08:00 as 13:30","08:00 \u00e0s 13:00","07:30 as 21:00","08:00 as 13:30","08:00 \u00e0s 13:00","07:30 as 21:00"],"1004":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1005":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1006":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1007":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1008":["8:00 as 13:00","08:00 \u00e0s 13:00","8:00 as 19:30","8:00 as 13:00","08:00 \u00e0s 13:00","8:00 as 19:30"],"1009":["8:00 as 20:00","08:00 \u00e0s 20:00","8:00 as 22:00","8:00 as 20:00","08:00 \u00e0s 20:00","8:00 as 22:00"],"1010":["08:00 a 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 a 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1011":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1012":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1013":["07:30 as 13:00","07:30 \u00e0s 13:00","07:30 as 20:30","07:30 as 13:00","07:30 \u00e0s 13:00","07:30 as 20:30"],"1014":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00"],"1015":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1016":["08:00 as 13:00","08:00 as 20:00","08:00 as 13:00","08:00 as 20:00"],"1017":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1018":["07:30 as 13:00","08:00 \u00e0s 13:00","07:30 as 20:00","07:30 as 13:00","08:00 \u00e0s 13:00","07:30 as 20:00"],"1019":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1020":["8:00 as 13:00","8:00 as 13:00","8:00 as 21:00","8:00 as 13:00","8:00 as 13:00","8:00 as 21:00"],"1021":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1022":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:00"],"1023":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1024":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30"],"1025":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1026":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:30"],"1027":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:30","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 19:30"],"1028":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1029":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00"],"1030":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1031":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1032":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 22:00"],"1033":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 20:00"],"1034":["08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00","08:00 as 13:00","08:00 \u00e0s 13:00","08:00 as 21:00"],"1035":["08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 21:00","08:00 as 20:00","08:00 \u00e0s 20:00","08:00 as 21:00"],"1036":["8h \u00e0s 13h.","Fechado","08:00 \u00e0s 19:30","8h \u00e0s 13h.","Fechado","08:00 \u00e0s 19:30"],"1038":["8h \u00e0s 19h.","08:00 \u00e0s 19:00","08:00 \u00e0s 22:00","8h \u00e0s 19h.","08:00 \u00e0s 19:00","08:00 \u00e0s 22:00"],"1040":["07:30 as 19:00","07:30 \u00e0s 19:00","07:30 as 21:00","07:30 as 19:00","07:30 \u00e0s 19:00","07:30 as 21:00"],"1041":["08:00 as 19:00","08:00 \u00e0s 19:00","08:00 as 21:00","08:00 as 19:00","08:00 \u00e0s 19:00","08:00 as 21:00"],"1042":[" 08:00 as 19:30 ","08:00 \u00e0s 21:00","08:00 as 21:00"," 08:00 as 19:30 ","08:00 \u00e0s 21:00","08:00 as 21:00"],"1043":["08:00 as 19:00","08:00 as 21:00","08:00 as 19:00","08:00 as 21:00"]};


*/

